import React, { Component } from 'react';

export default class TypewriterEffect extends Component {
    charIndex = 0;
    letText = '';
    timeout = null;

    constructor(props) {
        super(props);
        this.state = {
            displayedText: ''
        };
    }

    animText(text){
        this.letText = text;
        this.charIndex = 0;

        const recursivelyAddChar = ()=>{
            clearTimeout(this.timeout);
            const currDisplayedText = this.charIndex > 0 ? this.state.displayedText : '';
            if(this.charIndex < this.letText.length){
                const newChar = this.letText.charAt(this.charIndex);
                var toAdd = newChar;
                if(newChar == '<'){
                    toAdd = this.letText.substring(this.charIndex, this.letText.indexOf('>', this.charIndex)+1);
                    this.charIndex = this.letText.indexOf('>', this.charIndex);
                }

                this.setState({
                    displayedText: currDisplayedText + toAdd
                });
                this.charIndex++;
                this.timeout = setTimeout(recursivelyAddChar, 100);
            }
        }

        recursivelyAddChar();
    }

    componentWillUnmount(){
        clearTimeout(this.timeout);
    }

    render() {
        const { textProps } = this.props;
        
        return (
            <p {...textProps} dangerouslySetInnerHTML={{__html: this.state.displayedText }} /> 
        );
    }
}
